const LOCATION_TYPE = {
  STATE: 'state',
  COUNTRY: 'country',
  CITY: 'city',
  ALIAS: 'alias',
  CITY_ALIAS: 'city_alias',
  CITY_HIGHLIGHTED: 'city_highlighted',
  HOTEL: 'hotel',
};

export default LOCATION_TYPE;
